import React from "react";
import "./Modal.scss";

interface ModalProps {
  isOpen: boolean;
  title?: string;
  description?: string; 
  content: React.ReactNode; 
  onClose: () => void;
  footerActions?: React.ReactNode; 
  contentClass?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  title,
  description,
  content,
  onClose,
  footerActions,
  contentClass,

}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-content ${contentClass || ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          {description && <p className="modal-description">{description}</p>}
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
          {/* <hr /> */}
        </div>
        <div className="modal-body">{content}</div>
        {footerActions && <div className="modal-footer">{footerActions}</div>}
      </div>
    </div>
  );
};

export default Modal;
